// extracted by mini-css-extract-plugin
export default {"toast":"CustomToast_toast__cCf7V","add":"CustomToast_add__WdUH+","remove":"CustomToast_remove__kQMY8","show":"CustomToast_show__Se9yJ","hide":"CustomToast_hide__TwlB5"};